import React, { Component, Fragment } from 'react'
import QuantityChanger from '../Components/QuantityChanger'
import { isNullOrWhiteSpace } from '../Services/strings'

class QuantityChangerContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            quantity: !isNullOrWhiteSpace(props.defaultQuantity)
                ? props.defaultQuantity
                : '1',
        }
    }

    handleQuantityUpdate(quantity) {
        if (this.props.handleQuantityUpdate)
            this.props.handleQuantityUpdate(quantity)
        this.setState({ quantity: quantity })
    }

    render() {
        return (
            <Fragment>
                <input
                    type="hidden"
                    id={this.props.quantityFieldId}
                    value={this.state.quantity}
                ></input>
                <QuantityChanger
                    {...{
                        quantity: this.state.quantity,
                        updateQuantity: (updatedQuantity) =>
                            this.handleQuantityUpdate(updatedQuantity),
                        maxQuantity: this.props.maxQuantity,
                    }}
                />
            </Fragment>
        )
    }
}

export default QuantityChangerContainer
